import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
var BasicModal = function (props) {
    var children = props.children, header = props.header, toggle = props.toggle;
    return (React.createElement(Modal, { isOpen: true, toggle: toggle },
        React.createElement(ModalHeader, { toggle: toggle }, header),
        React.createElement(ModalBody, null, children)));
};
BasicModal.propTypes = {
    children: PropTypes.node.isRequired,
    header: PropTypes.node.isRequired,
    toggle: PropTypes.func.isRequired,
};
export default BasicModal;
